import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { DecodedToken } from '../models/auth.interface';
import { TokenSession } from '../models/users.interface';
import { AuthService } from '../services/auth/auth';

/**
 * Intercepts HTTP requests to check for a valid access token.
 * If the token is about to expire, it refreshes the token.
 * If no token is found, it redirects to the login page.
 */
export const TokenRefreshInterceptor: HttpInterceptorFn = (req, next) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const isRefreshing = localStorage.getItem('is_refresh');
    const exceptions = ['login'];

    const currentpath = req.url;
    if (exceptions.includes(currentpath)) {
        return next(req);
    }
    const token = auth.getAccessToken();
    if (!token) {
        // If no token is found, redirect to login
        router.navigate(['/login']);
        return next(req);
    }

    const decodedToken: DecodedToken = jwtDecode(token);
    const expirationDate = new Date(decodedToken.exp * 1000);
    const currentDate = new Date();
    const minutesToExpiration =
        (expirationDate.getTime() - currentDate.getTime()) / 60000;
    const MINUTES_TO_REFRESH = 2;

    //se puede refrescar el token; refrecarse solo cuando falten 2 minuto.
    if (minutesToExpiration < MINUTES_TO_REFRESH && !isRefreshing) {
        localStorage.setItem('is_refresh', 'true');
        const parseToken = JSON.parse(token) as TokenSession
        auth.refreshToken(parseToken.refresh).subscribe((newToken) => {
            auth.storeAccessToken(newToken.access);
            localStorage.removeItem('is_refresh');
        });
    }
    return next(req);
};
